<template>
  <div class="ideas">
    <b-list-group>
      <b-list-group-item v-if="ideasWithCountry.length > 0" v-for="idea in ideasWithCountry" v-bind:key="idea.id">
        <Idea
          :country="idea.author_country"
          :post-id="idea.id"
          :post-slug="idea.slug"
          :ideaTitle="idea.title.rendered"
          :authorPic="idea._embedded.author[0].avatar_urls['96']"
          :ideaCategories="getIdeaChallengeCategories(idea._embedded['wp:term'])"
          :author="idea._embedded.author[0].name"
          :author-slug="idea._embedded.author[0].slug"
          :communityCategories="getCommunityCategories(idea._embedded['wp:term'])"
          :date="idea.date"
          :content="idea.content.rendered"
          :comments="idea._embedded.replies"
          :likes="idea.total_likes[0]"
          :excerpt="excerpt"
          :supporting-doc="idea.idea_supporting_documentation[0]">
        </Idea>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import Idea from '@/components/Idea'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import UtilityMethods from '@/helpers/UtilityMethods.js'
export default {
  props: [
    'ideas',
    'excerpt'
  ],
  components: {
    Idea
  },
  data () {
    return {
      ideasWithCountry: []
    }
  },
  created () {
    var authorIDs = UtilityMethods.arrayRemoveDuplicates(this.ideas.map(x => x.author))
    WordpressRestAPI.getViewContent('users/?include=' + authorIDs.join())
      .then(response => {
        this.ideasWithCountry = this.ideas.map(function (x) {
          for (var i = 0; i < response.data.length; i++) {
            if (x.author === response.data[i].id) {
              x['author_country'] = 'flag-' + response.data[i].meta.country.replace(/ /g, '').toLowerCase()
              return x
            }
          }
        })
      })
      .catch(e => {
        console.error(e)
      })
  },
  methods: {
    setChallengeLink: function (category) {
      return category.slug
    },
    getIdeaChallengeCategories: function (categoryTerms) {
      let ideaCat = []
      for (var i = 0; i < categoryTerms.length; i++) {
        if (categoryTerms[i][0].taxonomy === 'idea_chalenge_category') {
          for (var j = 0; j < categoryTerms[i].length; j++) {
            ideaCat.push({id: categoryTerms[i][j].id, name: categoryTerms[i][j].name, slug: this.setChallengeLink(categoryTerms[i][j])})
          }
        }
      }
      return ideaCat
    },
    getCommunityCategories: function (categoryTerms) {
      let comCat = []
      for (var i = 0; i < categoryTerms.length; i++) {
        if (categoryTerms[i][0].taxonomy === 'community_categories') {
          for (var j = 0; j < categoryTerms[i].length; j++) {
            comCat.push({id: categoryTerms[i][j].id, name: categoryTerms[i][j].name})
          }
        }
      }
      return comCat
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Ideas.vue